// @view/panels/demographic/ZipcodeError.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import type { VisibilityPhase } from "@ps-bridge/models/ui/visibilityPhase";
import ZipcodeErrorView from "@view/demographic/ZipcodeError.view";

export type ZipcodeErrorPanelProps = {
  phase: VisibilityPhase;
  message: string;
};

const ZipcodeErrorPanel: React.FC<ZipcodeErrorPanelProps> = ({ phase, message }) => {
  const phaseKeys = {
    hidden: "hidden",
    visible: "visible",
  } as const satisfies Record<VisibilityPhase, VisibilityPhase>;

  const render = {
    [phaseKeys.hidden]: <EmptyView />,
    [phaseKeys.visible]: <ZipcodeErrorView message={message} />,
  } as const satisfies Record<VisibilityPhase, React.ReactElement>;

  return render[phase as keyof typeof render];
};

export default React.memo(ZipcodeErrorPanel, (prevProps, nextProps) => {
  return prevProps.phase === nextProps.phase && prevProps.message === nextProps.message;
});
